<template>
  <div style="display: flex;margin-bottom: 30px" class="steps">
    <div v-for="(item,i) in list"
         :style="{width:`${100/list.length}%`,position: 'relative'}"
         :key="i">
      <div :class="steps==i+1?'action':steps>i+1?'stepsok':''"
           class="mintitle">
        <span class="context">
          {{ item }}
        </span>
      </div>
      <span v-if="list.length>i+1" class="to_right"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Steps",
  props: {
    list: {
      type: Array,
      default:()=>{return []}
    },
    steps: {
      type: [String, Number],
      default: 1
    }
  },
}
</script>

<style lang="scss"
       scoped>
.steps{
  counter-reset: section;
  .mintitle {
    display: inline-block;
    width: 100%;
    background: #EEEEEE;
    color: #666;
    height: 48px;
    line-height: 48px;
    text-align: center;
    margin-left: 2px;

    .context{
      &:before{
        counter-increment: section;
        content: counter(section);
        display: inline-block;
        border: 1px solid #B5B5B5;
        height: 2em;
        width: 2em;
        position: absolute;
        margin-left: -2.5em;
        margin-top: 0.7em;
        line-height: 2em;
        border-radius: 50%;
      }
    }

    + .to_right {
      position: absolute;
      right: 0;
      top:0;
      z-index: 1;

      &:after {
        position: absolute;
        content: '';
        border-left: 30px solid #EEEEEE;
        border-top: 24px solid transparent;
        border-bottom: 24px solid transparent;
      }

      &:before {
        position: absolute;
        top: -4px;
        content: '';
        border-left: 34px solid #fff;
        border-top: 28px solid transparent;
        border-bottom: 28px solid transparent;
      }
    }
  }

  .action {
    background: #B79255;
    color: #fff;

    + .to_right {
      &:after {
        border-left: 30px solid #B79255;
      }
    }
    .context{
      &:before{
        border-color: #fff;
      }
    }
  }
  .stepsok {
    &:before {
      border: none;
      display: inline-block;
      width: 25px;
      height: 25px;
      content: '';
      //background-image: url("../../assets/public/success.png");
      position: relative;
      top: 7px;
    }
  }
}

</style>
